import { useState } from 'react';
import { useDemo2Ctx } from '../Demo2Context';
import { ZONES, WORKERS, TYPE_ICON_RI, workHistoryPhoto } from '../demo2Data';
import Demo2PhotoLightbox from '../Demo2PhotoLightbox';

export default function Demo2WorkHistory() {
    const { workHistory, toast } = useDemo2Ctx();
    const [zoneVal, setZoneVal] = useState('all');
    const [typeVal, setTypeVal] = useState('all');
    const [workerVal, setWorkerVal] = useState('all');
    const [lightboxIdx, setLightboxIdx] = useState<number | null>(null);

    const list = workHistory.filter(h => {
        if (zoneVal !== 'all' && h.zone !== zoneVal) return false;
        if (typeVal !== 'all' && h.type !== typeVal) return false;
        if (workerVal !== 'all' && h.worker !== workerVal) return false;
        return true;
    });

    return (
        <div className="list-page">
            <div className="list-bar">
                <select className="form-select" style={{ width: 190, height: 32, fontSize: 12 }} value={zoneVal} onChange={e => setZoneVal(e.target.value)}>
                    <option value="all">전체 관리구역</option>
                    {ZONES.map(z => <option key={z.id} value={z.id}>{z.name}</option>)}
                </select>
                <select className="form-select" style={{ width: 130, height: 32, fontSize: 12 }} value={typeVal} onChange={e => setTypeVal(e.target.value)}>
                    <option value="all">전체 작업종류</option>
                    <option>관개</option><option>전정</option><option>방제</option><option>시비</option><option>배수개선</option>
                </select>
                <select className="form-select" style={{ width: 140, height: 32, fontSize: 12 }} value={workerVal} onChange={e => setWorkerVal(e.target.value)}>
                    <option value="all">전체 작업자</option>
                    {WORKERS.map(w => <option key={w.name}>{w.name}</option>)}
                </select>
                <input type="date" className="form-input" style={{ width: 150, height: 32, fontSize: 12 }} defaultValue="2026-07-01" />
                <span className="text-muted text-xs">~</span>
                <input type="date" className="form-input" style={{ width: 150, height: 32, fontSize: 12 }} defaultValue="2026-07-20" />
                <div style={{ flex: 1 }} />
                <span className="text-xs text-muted">{list.length}건</span>
                <button className="btn btn-secondary btn-sm" onClick={() => toast('Excel 내보내기', 'success')}><i className="ri-download-2-line" /> Excel</button>
            </div>
            <div style={{ flex: 1, overflowY: 'auto', padding: '18px 20px' }}>
                <div className="timeline">
                    {list.length === 0 && (
                        <div className="d2-empty">
                            <i className="ri-history-line" />
                            <div className="d2-empty-txt">조건에 해당하는 이력이 없습니다</div>
                        </div>
                    )}
                    {list.map((r, i) => {
                        const delta = r.after - r.before;
                        const photo = workHistoryPhoto(i);
                        return (
                            <div key={i} className={`tl-item fade-up d${i % 5}`}>
                                <div className="tl-dot"><i className={TYPE_ICON_RI[r.type] || 'ri-file-list-3-line'} /></div>
                                <div className="tl-body">
                                    <div className="tl-meta">{r.date} · {r.zoneName} · {r.worker}</div>
                                    <div className="tl-card tl-card-photo">
                                        <div className="tl-card-main">
                                            <div className="tl-card-top"><span className="tl-card-name">{r.type} · {r.method}</span><span className="badge badge-good">완료</span></div>
                                            <div className="tl-stats">
                                                <div className="tl-stat"><div className="tl-stat-lbl">관개량</div><div className="tl-stat-val">{r.amt}</div></div>
                                                <div className="tl-stat"><div className="tl-stat-lbl">소요시간</div><div className="tl-stat-val">{r.mins}</div></div>
                                                <div className="tl-stat"><div className="tl-stat-lbl">수분 변화</div><div className="tl-stat-val" style={{ fontSize: 11.5, color: delta >= 0 ? 'var(--good)' : 'var(--danger)' }}>{r.before}%→{r.after}% ({delta >= 0 ? '+' : ''}{delta}%p)</div></div>
                                            </div>
                                            <div style={{ marginTop: 9, fontSize: 11.5, color: 'var(--text2)', background: 'var(--surface2)', borderRadius: 7, padding: '8px 10px' }}><i className="ri-file-text-line" /> {r.note}</div>
                                        </div>
                                        <div className="tl-card-thumb" onClick={() => setLightboxIdx(i)}>
                                            <img src={photo.src} alt={photo.caption} loading="lazy" />
                                            <span className="tl-card-thumb-zoom"><i className="ri-zoom-in-line" /></span>
                                            <span className="tl-card-thumb-cap">{photo.caption}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
            {lightboxIdx !== null && (
                <Demo2PhotoLightbox
                    photos={[workHistoryPhoto(lightboxIdx)]}
                    index={0}
                    onClose={() => setLightboxIdx(null)}
                    onIndexChange={() => { /* 항목당 사진 1장이라 이동 불필요 */ }}
                />
            )}
        </div>
    );
}
